import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../store/hooks/store.hooks";
import { findGame, clearFilter } from "../../../store/models/slots/slot.slice";
import { ProviderSelect } from "../ProviderSelect/providerSelect";
import { SearchPopup } from "../SlotsSearchPopup/search.popup";
import "./SlotFilters.css";

interface ISlotFiltersProp {
  isMain: boolean;
  section: "main" | "slots" | "live" | "crash";
  filters: {
    name: string;
    image: string;
    path: string;
  }[];
  providerChangeHandler: (providerId: number) => void;
}
export const SlotFilters = ({
  section,
  isMain,
  filters,
  providerChangeHandler,
}: ISlotFiltersProp) => {
  // const [active, setActive] = useState(false);
  const { t } = useTranslation();
  const [gameName, setGameName] = useState("");
  const [searchPopup, setSearchPopup] = useState(false);
  const dispatch = useAppDispatch();
  const navigator = useNavigate();
  const applyFilter = (path: string) => {
    navigator(path);
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (gameName.trim()) {
        dispatch(findGame(gameName));
      } else {
        dispatch(clearFilter());
      }
    }, 700);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameName]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const currentValue = e.target.value;
    setGameName(currentValue);
    setSearchPopup(currentValue.length > 0);
  };
  useEffect(() => {
    if (!searchPopup) {
      dispatch(clearFilter());
    }
  }, []);
  return (
    <Box className="slots-filter">
      <Box className="slots-filter__search-container">
        <input
          placeholder="🔍    E.g. Book Of Dead"
          onChange={handleSearchChange}
          onClick={(e) => e.stopPropagation()}
          value={gameName}
          id="slots-search"
        />
        {isMain && (
          <SearchPopup
            gameName={gameName}
            active={searchPopup}
            setActive={setSearchPopup}
          />
        )}
        <ProviderSelect section={section} onClick={providerChangeHandler} />
      </Box>
      <Box className="slots-filter__categories-container">
        {filters.map((filter) => {
          return (
            <Box
              className="slots-filter__categories-button"
              key={"filter_" + filter.name}
              onClick={() => {
                applyFilter(filter.path);
              }}
            >
              <img src={filter.image} alt={filter.name} />
              {t(`slots.lobby.heading.${filter.name}`)}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
